export enum TRIAL_NAMES {
  CLUSTER_CONNECTING = "cluster-connecting",
  CLUSTER_CONNECTED = "cluster-connected",
  TRIAL = "trial",
}
